import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import './PaymentForm.scss';

const PaymentForm = (props) => {
  const { delictId } = props.match.params;
  const [paymentData, setPaymentData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const formRef = useRef(null);
  let history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(`/payment/status/${delictId}`);
  }

  useEffect(() => {
    axios.get(`/borica/request/${delictId}`)
      .then(response => {
          const formData = response.data;

          setPaymentData({
            ADDENDUM: formData.ADDENDUM,
            AMOUNT: formData.AMOUNT,
            COUNTRY: formData.COUNTRY,
            CURRENCY: formData.CURRENCY,
            CUST_BOR_ORDER_ID: formData.CUST_BOR_ORDER_ID,
            DESC: formData.DESC,
            MERCHANT: formData.MERCHANT,
            MERCH_GMT: formData.MERCH_GMT,
            MERCH_NAME: formData.MERCH_NAME,
            NONCE: formData.NONCE,
            ORDER: formData.ORDER,
            P_SIGN: formData.P_SIGN,
            TERMINAL: formData.TERMINAL,
            TIMESTAMP: formData.TIMESTAMP,
            TRTYPE: formData.TRTYPE,
            macSourceValue: formData.macSourceValue,
            paymentUrl: formData.paymentUrl,
          });

          return formData;
      })
      .then((formData) => {
        formRef.current.submit();
      })
      .catch(e => console.log(e));
  }, []);

  return(
    <div className="wrapper">
      {submitting &&
       <div>Submtting Form...</div>
     }
      <form ref={formRef} onSubmit={handleSubmit} action={paymentData.paymentUrl} method="post">
        <fieldset>
          <label>
            <input type="hidden" name="TERMINAL" value={paymentData.TERMINAL} />
          </label>
          <label>
            <input type="hidden" name="TRTYPE" value={paymentData.TRTYPE} />
          </label>
          <label>
            <input type="hidden" name="AMOUNT" value={paymentData.AMOUNT} />
          </label>
          <label>
            <input type="hidden" name="CURRENCY" value={paymentData.CURRENCY} />
          </label>
          <label>
            <input type="hidden" name="ORDER" value={paymentData.ORDER} />
          </label>
          <label>
            <input type="hidden" name="DESC" value={paymentData.DESC} />
          </label>
          <label>
            <input type="hidden" name="MERCHANT" value={paymentData.MERCHANT} />
          </label>
          <label>
            <input type="hidden" name="MERCH_NAME" value={paymentData.MERCH_NAME} />
          </label>
          <label>
            <input type="hidden" name="COUNTRY" value={paymentData.COUNTRY} />
          </label>
          <label>
            <input type="hidden" name="MERCH_GMT" value={paymentData.MERCH_GMT} />
          </label>
          <label>
            <input type="hidden" name="ADDENDUM" value={paymentData.ADDENDUM} />
          </label>
          <label>
            <input type="hidden" name="AD.CUST_BOR_ORDER_ID" value={paymentData.CUST_BOR_ORDER_ID} />
          </label>
          <label>
            <input type="hidden" name="NONCE" value={paymentData.NONCE} />
          </label>
          <label>
            <input type="hidden" name="TIMESTAMP" value={paymentData.TIMESTAMP} />
          </label>
          <textarea name="P_SIGN" className="text-hidden" readOnly value={paymentData.P_SIGN} ></textarea>
        </fieldset>   
        <input type="submit" value="Submit" className="submit-btn" />
      </form>
    </div>
  )
}

export default PaymentForm;